import React, { useLayoutEffect, useRef } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';

am4core.useTheme(am4themes_animated);

const GroupedBarChart = (props: any) => {
  const chartRef = useRef<any>(null);

  useLayoutEffect(() => {
    let chart = am4core.create('chartdiv', am4charts.XYChart);

    // Add data
    chart.data = props.data;

    // Create axes
    let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'freq';
    categoryAxis.title.text = 'Frequency';
    categoryAxis.title.fill = am4core.color("#ffffff");  // Axis title color
    categoryAxis.renderer.labels.template.fill = am4core.color("#ffffff"); // Axis label color
    categoryAxis.renderer.grid.template.stroke = am4core.color("#ffffff"); // Grid lines color

    // Increase space between groups
    categoryAxis.renderer.cellStartLocation = 0.1;  // Increase to add more space between groups
    categoryAxis.renderer.cellEndLocation = 0.9;    // Increase this as well for spacing

    categoryAxis.renderer.labels.template.adapter.add("textOutput", function(text) {
      return text.replace(/_/g, ' ') // Replace underscores with spaces
                 .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
  });

    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.title.text = 'Percent Mean Growth(%)';
    valueAxis.title.fill = am4core.color("#ffffff");  // Axis title color
    valueAxis.renderer.labels.template.fill = am4core.color("#ffffff");  // Axis label color
    valueAxis.renderer.grid.template.stroke = am4core.color("#ffffff");  // Grid lines color

    // Function to generate HTML for nested properties
    function getPropertiesHTML(properties:any) {
        if (!properties) return '';
      
        return Object.entries(properties).map(([key, value]:any) => {
          const formattedKey = key.replace(/_/g, ' ').replace(/\b\w/g, (char:any) => char.toUpperCase());
          return `<span>${formattedKey}:</span> ${value.toFixed(2)}%<br/>`;
        }).join('');
    }

    // Create series
    function createSeries(field:any, name:any, color:any, propertiesField:any) {
      let series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = field;
      series.dataFields.categoryX = 'freq';
      series.name = name;
      series.columns.template.fill = am4core.color(color);  // Set bar color

      // Adjust bar width
      series.columns.template.width = am4core.percent(80);  // Set width for bars, reduce to adjust spacing between bars

      // Disable clustering to reduce space between bars in the same group
      

      // Add detailed tooltip for each bar
      series.columns.template.adapter.add("tooltipHTML", (html, target:any) => {
        let data:any = target.dataItem.dataContext;
        let propertiesHTML = getPropertiesHTML(data[propertiesField]);
        const formatCategoryX = (category:any) => category ? category.replace(/_/g, ' ').split(' ').map((word:any) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : "Unknown";
        const formattedCategoryX = formatCategoryX(data.freq);
        return `<strong>${formattedCategoryX} - ${name} Growth Rates</strong><br/><strong>${name} Growth: {${field}}%</strong><br/>${propertiesHTML}`;
      });

      let hoverState = series.columns.template.states.create("hover");
    }

    createSeries('homesales_percent_mean_growth', 'Home Sales', '#FFAD33', 'homesaleProperties');
    createSeries('msp_percent_mean_growth', 'MSP', '#00E396', 'msp_properties');
    createSeries('ppsf_percent_mean_growth', 'PPSF', '#58A9FB', 'ppsf_properties');
    createSeries('population_percent_mean_growth', 'Population', '#ED4B82', 'population_properties');

    // Add legend
    chart.legend = new am4charts.Legend();
    chart.legend.labels.template.fill = am4core.color("#ffffff");
    chart.legend.dy = -10;

    let label = chart.chartContainer.createChild(am4core.Label);
    label.text = "Average Growth (Year on Year)";
    label.align = "center";
    label.valign = "bottom";
    label.dy = 56;
    label.fill = am4core.color("#ffffff");
    label.fontWeight='700'

    chartRef.current = chart;

    return () => {
      chart.dispose();
    };
  }, [props.data]);


  return <div id="chartdiv" style={{ width: '100%', height: '500px' }} />;
};

export default GroupedBarChart;